import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description RubleSign icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RubleSign } from '@sravni/design-system-icons'
 *
 * <RubleSign />
 * ```
 */
var RubleSign = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "RubleSign", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.163 13.75v-7.5h3.148c1.107 0 2.004.84 2.004 1.875 0 1.036-.897 1.875-2.004 1.875M11.308 10H6.667M10.833 12.292H6.667", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { RubleSign };
//# sourceMappingURL=RubleSign.js.map
